export default function useRateUtility() {

    return {
        rateTypes: [
            { "name": "Window", "value": 1 },
            { "name": "Standard", "value": 2 }
        ],
        rateModes: [
            { "name": "Flat", "value": 1 },
            { "name": "Percentage", "value": 2 },
            { "name": "Quantity", "value": 3 },
            { "name": "Weight", "value": 4 }
        ],
        getRateType: function (value) {
            let valueFormatted = parseInt(value);
            return this.rateTypes.find(x => x.value === valueFormatted);
        },
        getRateMode: function (value) {
            let valueFormatted = parseInt(value);
            return this.rateModes.find(x => x.value === valueFormatted);
        }
    };
}
